import { useEffect, useState } from 'react';
import type { FileItem } from '../lib/types';
import { Modal, Spinner } from './ui';
import { mintMediaUrl } from '../lib/api';
import { fileKind } from '../lib/format';

export function FilePreviewModal({ file, onClose }: { file: FileItem; onClose: () => void }) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    mintMediaUrl(file.id, 'preview')
      .then((u) => active && setUrl(u))
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
    };
  }, [file.id]);

  const kind = fileKind(file.mime_type);

  return (
    <Modal title={file.name} onClose={onClose} size="xl">
      {failed ? (
        <p className="text-sm text-red-600">Could not load a preview.</p>
      ) : !url ? (
        <Spinner label="Preparing preview…" />
      ) : kind === 'image' ? (
        <img src={url} alt={file.name} className="mx-auto max-h-[72vh] object-contain" />
      ) : kind === 'video' ? (
        <video src={url} controls className="max-h-[72vh] w-full" />
      ) : kind === 'audio' ? (
        <audio src={url} controls className="w-full" />
      ) : kind === 'pdf' ? (
        <iframe src={url} title={file.name} className="h-[72vh] w-full rounded border border-slate-200" />
      ) : (
        <p className="text-sm text-slate-500">No in-app preview for this file type.</p>
      )}
    </Modal>
  );
}
